import { WSTableCellProps } from "@wingspanhq/fe-component-library";
import {
  IPayableSchema,
  IWorkLog,
  WorkLogStatus
} from "@wingspanhq/payments/dist/interfaces";

type GetWorkLogStatusCellPropsParams = {
  workLog: IWorkLog;
  payable?: IPayableSchema;
};

export function getWorkLogPayerStatusCellProps({
  workLog,
  payable
}: GetWorkLogStatusCellPropsParams): WSTableCellProps {
  switch (workLog.status) {
    case WorkLogStatus.Approved:
      return {
        secondaryText: payable?.invoiceNumber
          ? `Invoiced #${payable.invoiceNumber}`
          : undefined,
        pill: {
          text: "Approved",
          theme: "success",
          icon: "check-circle"
        }
      };

    case "InReview" as WorkLogStatus: {
      const editingRequested = !!(workLog as any)?.payeeOwnedData?.comment;
      return {
        secondaryText: editingRequested
          ? "Contractor requested editing"
          : "Awaiting your approval",
        secondaryTextColor: "amber400",
        pill: {
          text: "Action required",
          theme: "warning",
          icon: "alert"
        }
      };
    }

    case "InProgress" as WorkLogStatus:
      return {
        secondaryText: "Awaiting resubmission",
        pill: {
          text: "Awaiting contractor",
          theme: "neutral",
          icon: "time"
        }
      };

    case "Rejected" as WorkLogStatus:
      return {
        secondaryText: workLog.invoiceId ? "Cancelled invoice" : "Not invoiced",
        pill: {
          text: "Rejected",
          theme: "error",
          icon: "block"
        }
      };

    case WorkLogStatus.Draft:
    default:
      return {
        pill: {
          text: "Draft",
          theme: "neutral",
          icon: "draft"
        }
      };
  }
}
